import React, { useEffect, useState } from "react";
import { CardItem } from "../../common/Card/Card";
import Pagination from "../../common/Pagination";
import { Col, Row, Card, Tab, Nav } from 'react-bootstrap';
import Link from "../../common/Link";
import './Giocatore.css';
import { randomInteger } from "../../helpers/Random";
import Sidebar from "../../components/Sidebar";
import Advertising from "../../common/Advertising";
import CssLoader from "../../components/cssloader/CssLoader";
// import { apiGet } from "../../services/Api";

const seasonStatistics: Record<string, Record<string, number>> = {
    "2025/2026": {
        "Gol realizzati": 10,
        "Media gol per partita": 0.5,
        "Assist": 0,
        "Rigori": 0,
        "Partite giocate": 60,
        "Minuti giocati": 895,
        "Ammonizioni": 0,
        "Espulsioni": 0
    },
    "2024/2025": {
        "Gol realizzati": 5,
        "Media gol per partita": 0.2,
        "Assist": 3,
        "Rigori": 1,
        "Partite giocate": 55,
        "Minuti giocati": 810,
        "Ammonizioni": 1,
        "Espulsioni": 0
    }
};

export default function GiocatorePage() {
    const [playerCards, setPlayerCards] = useState<CardItem[]>([]);
    const [isMount, setIsMount] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageLimit = 8;
    const pageNeighbours = 5;

    useEffect(() => {
        if (!isMount) {
            getPlayerData();
            setIsMount(true);
        }
    }, [getPlayerData, isMount]);

    const cardExample = (): CardItem => {
        const articleId = randomInteger(1, 160);

        return {
            id: articleId,
            title: 'Partita pazzesca al palazzetto Manzoni',
            subtitle: <>20/07/2026 - <span className="author-name">Ufficio stampa - Milano FUTSAL</span></>,
            content: 'Durante il match di ieri sera il calciatore Giovinastro ha calciato così forte che ha bucato la rete.',
            image: 'https://picsum.photos/id/' + randomInteger(15, 175) + '/695/415',
            link: '/articolo/' + articleId,
            linkTitle: 'Leggi la notizia'
        };
    }

    const createCards = (): CardItem[] => Array(8).fill(null).map(() => cardExample());

    // eslint-disable-next-line react-hooks/exhaustive-deps
    function getPlayerData() {
        setIsLoading(true);

        let playerCards: CardItem[] = [];
        // apiGet('?op=' + type).then((value) => {
        playerCards = [
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
            ...createCards(),
        ];
        // })

        setPlayerCards(playerCards);
        setIsLoading(false);
    }

    const paginationCards = playerCards.slice((currentPage - 1) * pageLimit, currentPage * pageLimit);

    return (
        <React.Fragment>
            <div className="contact-tag">Pino Pini</div>
            <Row>
                <Col id="content" xs={12} lg={9}>
                    <div className="player-header">
                        <img src="https://img.freepik.com/premium-psd/african-american-football-player-man_1368-43752.jpg" alt="Player" className="player-image" />
                        <div className="player-info">
                            <div className="player-details">
                                <div className="detail-item">
                                    <span className="detail-label">Età:</span>
                                    <span className="detail-value">40 - 10/07/1986</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Nazionalità:</span>
                                    <span className="detail-value">Italiana</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Altezza:</span>
                                    <span className="detail-value">180 cm</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Peso:</span>
                                    <span className="detail-value">75 kg</span>
                                </div>
                                <div className="detail-item">
                                    <span className="detail-label">Piede:</span>
                                    <span className="detail-value">Sinistro</span>
                                </div>
                            </div>
                            <div className="player-position-wrapper">
                                <div className="player-position">
                                    <div className="position-info">
                                        <span className="position-number">5</span>
                                        <span className="position-title">Portiere</span>
                                    </div>
                                    <div className="position-years">
                                        <span className="years-label">Anni di gioco</span>
                                        <span className="years-value">5</span>
                                    </div>
                                </div>
                                <div className="team-logo">
                                    <img src="https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/1119fa7e-c447-4ce8-8032-8ae1207e0cfe/6864b2c6-df59-4fb4-b192-37652692bcb7.png" alt="Team Logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="player-foreground" />

                    <div className="player-stats">
                        <h2>Statistiche stagionali</h2>
                        <Tab.Container id="stats-tabs" defaultActiveKey="2025/2026">
                            <Nav variant="tabs">
                                {Object.keys(seasonStatistics).map(season => (
                                    <Nav.Item key={season}>
                                        <Nav.Link eventKey={season}>{season}</Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                            <Tab.Content>
                                {Object.keys(seasonStatistics).map(season => (
                                    <Tab.Pane eventKey={season} key={season}>
                                        <div className="stats-grid">
                                            {Object.entries(seasonStatistics[season]).map(([key, value]) => (
                                                <div className="stat-item" key={key}>
                                                    <span className="stat-value">{value as React.ReactNode}</span>
                                                    <span className="stat-label">{key}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </Tab.Pane>
                                ))}
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                    <div className="player-teams">
                        <h2>Squadre in cui ha giocato</h2>
                        <hr />
                        <div className="team-logos">
                            <img src="https://www.calcioa5live.com/img/squadre/VARIE.png" alt="Team 1" />
                        </div>
                    </div>
                    <div className="player-articles">
                        <hr />
                        <Advertising code="banner-cat4" as="div" />
                        <h2 className="mt-2 mb-4">Ultimi articoli sul giocatore</h2>
                        {paginationCards.map((card, index) => (
                            <Card key={card.id}>
                                {index % 4 === 0 && index !== 0 && (
                                    <Advertising code="banner-cat5" as="div" />
                                )}
                                <Card.Body className="px-2">
                                    <Link href={card.link} title={card.linkTitle}>
                                        <Row key={card.id}>
                                            <Col className="team-img-container my-auto">
                                                {card.image && <img src={card.image} className="team-img" alt={card.altImageText} />}
                                            </Col>
                                            <Col md={8}>
                                                <Card.Title><strong>{card.title}</strong></Card.Title>
                                                <Card.Subtitle>{card.subtitle}</Card.Subtitle>
                                                <div className="card-text">{card.content}</div>
                                            </Col>
                                        </Row>
                                    </Link>
                                </Card.Body>
                            </Card>
                        ))}
                        <Pagination
                            totalRecords={playerCards.length}
                            pageLimit={pageLimit}
                            pageNeighbours={pageNeighbours}
                            currentPage={currentPage}
                            onPageChanged={(value: any) => { setCurrentPage(value) }}
                        />
                    </div>
                </Col>
                <Col id="sidebar" xs={12} lg={3} className="pt-3">
                    <Sidebar />
                </Col>
            </Row>

            <CssLoader active={isLoading} text="Caricamento del giocatore in corso..." />
        </React.Fragment>
    );
}
